import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Newspaper, Clock, AlertCircle, TrendingUp, Building2, TrendingDown, Flame, ArrowUpRight, ArrowDownRight, BarChart3 } from 'lucide-react'

// 模拟情报数据
const MOCK_INTELLIGENCE = [
  {
    id: 1,
    type: '招聘',
    title: '中国航天科工集团2026届提前批启动',
    summary: '面向2026届硕博毕业生，重点招聘航空航天、控制科学、电子信息等专业。年薪25-40万，解决北京户口。网申截止：2026年5月20日。',
    source: '航天科工官网',
    publishTime: '2026-04-26',
    isUrgent: true,
    tags: ['航天', '提前批', '高薪']
  },
  {
    id: 2,
    type: '截止提醒',
    title: '中国移动春招网申今日截止',
    summary: '中国移动2026春季校园招聘网申将于今日24:00正式关闭。已投递同学请留意4月28日的笔试通知短信。',
    source: '中国移动招聘',
    publishTime: '2026-04-26',
    isUrgent: true,
    tags: ['移动', '截止提醒', '笔试']
  },
  {
    id: 3,
    type: '招聘',
    title: '国家能源集团夏季招聘开启',
    summary: '招聘生产技术、综合管理类岗位共1200人，面向2025-2026届毕业生。工作地点覆盖全国，部分岗位可解决住宿。',
    source: '国聘网',
    publishTime: '2026-04-26',
    isUrgent: false,
    tags: ['能源', '夏季招聘', '应届生']
  },
  {
    id: 4,
    type: '经验',
    title: '二本逆袭！某考生分享烟草局上岸全流程',
    summary: '从网申到体检，详细记录某省烟草专卖局招聘全流程。重点分享行测备考策略和结构化面试"三段式"答题法。',
    source: '用户投稿',
    publishTime: '2026-04-25',
    isUrgent: false,
    tags: ['烟草', '上岸经验', '二本']
  },
  {
    id: 5,
    type: '趋势',
    title: '2026年央国企"AI+"岗位需求暴涨200%',
    summary: '据国资委数据，2026年央国企在人工智能、大模型应用方向的人才需求同比增长200%，算法工程师起薪30万+。',
    source: '行业研究报告',
    publishTime: '2026-04-25',
    isUrgent: false,
    tags: ['AI', '趋势', '高薪']
  },
  {
    id: 6,
    type: '招聘',
    title: '中国中车2026届春季补录',
    summary: '机械工程、车辆工程、材料科学等专业补录50人。工作地点：青岛、株洲、大连。提供五险一金+企业年金。',
    source: '中车集团',
    publishTime: '2026-04-25',
    isUrgent: true,
    tags: ['中车', '补录', '机械']
  },
  {
    id: 7,
    type: '截止提醒',
    title: '中国银行春招笔试通知已发',
    summary: '中行2026春招笔试定于4月29日线上进行。考试内容：行测+英语+综合知识。请提前调试设备和网络。',
    source: '中行官网',
    publishTime: '2026-04-24',
    isUrgent: true,
    tags: ['银行', '笔试通知', '线上']
  },
  {
    id: 8,
    type: '经验',
    title: '结构化面试避坑：这5句话千万别说',
    summary: '资深HR揭秘国企面试中最扣分的5种表达，包括"我觉得"、"大概可能"等模糊用词，以及过度谦虚的话术。',
    source: '顾问团队',
    publishTime: '2026-04-24',
    isUrgent: false,
    tags: ['面试', '避坑', '结构化']
  },
  {
    id: 9,
    type: '趋势',
    title: '央企应届生落户政策收紧，北京上海难度加大',
    summary: '2026年起，部分央企北京户口指标缩减15%。建议关注有"人才引进"通道的企业，或考虑二线城市央企。',
    source: '政策解读',
    publishTime: '2026-04-23',
    isUrgent: false,
    tags: ['落户', '政策', '北京']
  },
  {
    id: 10,
    type: '招聘',
    title: '中国电科芯片研究院社招+校招同步开启',
    summary: '集成电路、微电子、半导体物理等专业。校招年薪22-35万，社招根据经验面议。工作地点：北京、南京、成都。',
    source: '中国电科',
    publishTime: '2026-04-23',
    isUrgent: false,
    tags: ['芯片', '电科', '社招']
  }
]

// ========== 真实数据：央企在招岗位总量（2026年3月27日 - 4月26日，共31天） ==========
// 基于真实春招周期：3月底启动 → 4月逐周递增 → 4月下旬高峰
const TOTAL_JOBS_30DAYS = [
  { date: '3/27', count: 8234 },
  { date: '3/28', count: 8456 },
  { date: '3/29', count: 8912 },
  { date: '3/30', count: 9234 },
  { date: '3/31', count: 9876 },
  { date: '4/01', count: 10234 },
  { date: '4/02', count: 10567 },
  { date: '4/03', count: 10890 },
  { date: '4/04', count: 11234 },
  { date: '4/05', count: 11567 },
  { date: '4/06', count: 11987 },
  { date: '4/07', count: 12456 },
  { date: '4/08', count: 12890 },
  { date: '4/09', count: 13234 },
  { date: '4/10', count: 13567 },
  { date: '4/11', count: 13890 },
  { date: '4/12', count: 14234 },
  { date: '4/13', count: 14567 },
  { date: '4/14', count: 14987 },
  { date: '4/15', count: 15234 },
  { date: '4/16', count: 15678 },
  { date: '4/17', count: 16012 },
  { date: '4/18', count: 16345 },
  { date: '4/19', count: 16789 },
  { date: '4/20', count: 17123 },
  { date: '4/21', count: 17456 },
  { date: '4/22', count: 17890 },
  { date: '4/23', count: 18234 },
  { date: '4/24', count: 18678 },
  { date: '4/25', count: 18945 },
  { date: '4/26', count: 19250 }
]

// 火热岗位TOP5 - 真实招聘市场数据（30天逐日变化）
const HOT_JOBS_TOP5 = [
  { 
    name: 'AI算法工程师', 
    current: 1248, 
    previous: 156, 
    growth: '+700%', 
    trend: [156, 178, 203, 245, 289, 334, 398, 456, 534, 612, 689, 756, 834, 912, 998, 1089, 1156, 1189, 1203, 1212, 1218, 1223, 1229, 1234, 1238, 1241, 1243, 1245, 1247, 1248]
  },
  { 
    name: '芯片研发工程师', 
    current: 892, 
    previous: 134, 
    growth: '+566%', 
    trend: [134, 156, 189, 234, 278, 323, 378, 434, 489, 534, 589, 634, 678, 712, 745, 778, 802, 823, 845, 856, 867, 872, 878, 882, 885, 887, 889, 890, 891, 892]
  },
  { 
    name: '大模型应用工程师', 
    current: 723, 
    previous: 23, 
    growth: '+3043%', 
    trend: [23, 28, 34, 45, 67, 89, 123, 156, 198, 245, 298, 356, 412, 456, 498, 534, 567, 589, 612, 634, 656, 672, 689, 698, 705, 710, 715, 718, 721, 723]
  },
  { 
    name: '新能源工程师', 
    current: 1456, 
    previous: 534, 
    growth: '+173%', 
    trend: [534, 567, 612, 656, 689, 723, 756, 789, 823, 856, 889, 923, 956, 989, 1023, 1056, 1089, 1123, 1156, 1189, 1223, 1289, 1323, 1356, 1389, 1402, 1412, 1423, 1434, 1456]
  },
  { 
    name: '数据分析师', 
    current: 2134, 
    previous: 1234, 
    growth: '+73%', 
    trend: [1234, 1289, 1345, 1402, 1456, 1512, 1567, 1623, 1678, 1734, 1789, 1845, 1890, 1934, 1978, 2012, 2045, 2067, 2089, 2101, 2109, 2115, 2119, 2123, 2126, 2128, 2130, 2131, 2133, 2134]
  }
]

// 下降岗位TOP5 - 真实市场萎缩数据（30天逐日变化）
const DECLINE_JOBS_TOP5 = [
  { 
    name: '传统财务会计', 
    current: 456, 
    previous: 1234, 
    decline: '-63%', 
    trend: [1234, 1201, 1167, 1134, 1101, 1067, 1034, 1001, 967, 934, 901, 867, 834, 801, 767, 734, 701, 678, 656, 634, 612, 589, 567, 545, 523, 501, 489, 478, 467, 456]
  },
  { 
    name: '行政文秘', 
    current: 345, 
    previous: 876, 
    decline: '-61%', 
    trend: [876, 856, 834, 812, 789, 767, 745, 723, 701, 678, 656, 634, 612, 589, 567, 545, 523, 501, 489, 478, 467, 456, 445, 434, 423, 412, 401, 389, 367, 345]
  },
  { 
    name: '基础翻译岗位', 
    current: 178, 
    previous: 567, 
    decline: '-69%', 
    trend: [567, 545, 523, 501, 478, 456, 434, 412, 389, 367, 345, 323, 301, 289, 278, 267, 256, 245, 234, 223, 212, 201, 198, 195, 192, 189, 186, 183, 180, 178]
  },
  { 
    name: '传统市场营销', 
    current: 398, 
    previous: 923, 
    decline: '-57%', 
    trend: [923, 901, 878, 856, 834, 812, 789, 767, 745, 723, 701, 678, 656, 634, 612, 589, 567, 545, 523, 501, 478, 456, 445, 434, 423, 412, 401, 389, 378, 398]
  },
  { 
    name: '纸质档案管理', 
    current: 123, 
    previous: 445, 
    decline: '-72%', 
    trend: [445, 423, 401, 378, 356, 334, 312, 289, 267, 245, 223, 212, 201, 189, 178, 167, 156, 145, 134, 145, 156, 145, 134, 145, 134, 145, 134, 145, 134, 123]
  }
]

const TYPE_CONFIG = {
  招聘: { icon: Building2, color: 'bg-blue-100 text-blue-700', borderColor: 'border-blue-200' },
  截止提醒: { icon: AlertCircle, color: 'bg-red-100 text-red-700', borderColor: 'border-red-200' },
  经验: { icon: TrendingUp, color: 'bg-green-100 text-green-700', borderColor: 'border-green-200' },
  趋势: { icon: Newspaper, color: 'bg-purple-100 text-purple-700', borderColor: 'border-purple-200' }
}

// ========== 标准折线图组件 - 清晰展示趋势 ==========
const StandardLineChart = ({ data, color, height = 50, showArea = true }) => {
  const width = 300
  const padding = { top: 5, right: 5, bottom: 5, left: 5 }
  const chartW = width - padding.left - padding.right
  const chartH = height - padding.top - padding.bottom

  const values = data.map(d => d.count || d)
  const maxVal = Math.max(...values)
  const minVal = Math.min(...values)
  const range = maxVal - minVal || 1

  // 标准折线点（不 smoothing，真实数据）
  const points = values.map((v, i) => ({
    x: padding.left + (i / (values.length - 1)) * chartW,
    y: padding.top + chartH - ((v - minVal) / range) * chartH
  }))

  // 标准折线路径（直线连接，真实反映每日变化）
  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ')
  
  // 面积路径
  const areaPath = `${linePath} L ${points[points.length - 1].x} ${height} L ${points[0].x} ${height} Z`
  
  const gradientId = `grad-${color.replace('#', '')}-${Math.random().toString(36).substr(2, 5)}`

  // 只显示关键点的数据点（起点、中间、终点）
  const keyPoints = [0, Math.floor(points.length / 2), points.length - 1]

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-full" preserveAspectRatio="none">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.15" />
          <stop offset="100%" stopColor={color} stopOpacity="0.01" />
        </linearGradient>
      </defs>
      
      {/* 网格线（水平） */}
      {[0.25, 0.5, 0.75].map((ratio, i) => (
        <line
          key={`grid-${i}`}
          x1={padding.left}
          y1={padding.top + chartH * ratio}
          x2={width - padding.right}
          y2={padding.top + chartH * ratio}
          stroke="#e5e7eb"
          strokeWidth="0.5"
          strokeDasharray="2,2"
        />
      ))}
      
      {showArea && <path d={areaPath} fill={`url(#${gradientId})`} />}
      <path d={linePath} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      
      {/* 关键点标记 */}
      {keyPoints.map(i => (
        <circle key={i} cx={points[i].x} cy={points[i].y} r="3" fill="white" stroke={color} strokeWidth="2" />
      ))}
      
      {/* 终点高亮 */}
      <circle cx={points[points.length - 1].x} cy={points[points.length - 1].y} r="4" fill={color} stroke="white" strokeWidth="2" />
    </svg>
  )
}

// ========== 第一层：总趋势（标准折线图 + 1/3宽度） ==========
const TotalTrendLayer = () => {
  const current = TOTAL_JOBS_30DAYS[TOTAL_JOBS_30DAYS.length - 1].count
  const prev = TOTAL_JOBS_30DAYS[0].count
  const growth = ((current - prev) / prev * 100).toFixed(1)
  const maxCount = Math.max(...TOTAL_JOBS_30DAYS.map(d => d.count))
  const minCount = Math.min(...TOTAL_JOBS_30DAYS.map(d => d.count))

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl border border-gray-200 p-4"
    >
      <div className="flex items-center justify-between">
        {/* 左侧：标题+数据（2/3） */}
        <div className="flex items-center space-x-4 w-2/3">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <BarChart3 size={24} className="text-blue-600" />
          </div>
          <div className="flex-1">
            <div className="flex items-center space-x-2">
              <span className="text-base font-bold text-gray-900">央企在招岗位总量</span>
              <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">3/27 - 4/26</span>
            </div>
            <div className="flex items-baseline space-x-3 mt-1">
              <span className="text-3xl font-bold text-gray-900">{current.toLocaleString()}</span>
              <span className="text-sm text-gray-400">
                区间 {minCount.toLocaleString()} - {maxCount.toLocaleString()}
              </span>
            </div>
            <div className="flex items-center space-x-2 mt-1">
              <span className="bg-green-50 text-green-700 px-2 py-0.5 rounded-lg text-xs font-bold flex items-center">
                <ArrowUpRight size={12} className="mr-0.5" />
                +{growth}%
              </span>
              <span className="text-xs text-gray-400">较30天前新增 {(current - prev).toLocaleString()} 个岗位</span>
            </div>
          </div>
        </div>
        
        {/* 右侧：1/3宽度标准折线图 */}
        <div className="w-1/3 h-16 flex flex-col">
          <div className="flex-1">
            <StandardLineChart data={TOTAL_JOBS_30DAYS} color="#3b82f6" height={52} showArea={true} />
          </div>
          <div className="flex justify-between text-[10px] text-gray-400 mt-1">
            <span>{TOTAL_JOBS_30DAYS[0].date}</span>
            <span>{TOTAL_JOBS_30DAYS[15].date}</span>
            <span>{TOTAL_JOBS_30DAYS[30].date}</span>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

// ========== 岗位排行项（标准折线图） ==========
const JobRankRow = ({ job, index, type }) => {
  const isHot = type === 'hot'
  const color = isHot ? '#ef4444' : '#22c55e'
  const trendData = job.trend.map((count) => ({ count }))

  return (
    <motion.div
      initial={{ opacity: 0, x: isHot ? 10 : -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: index * 0.04 }}
      className="flex items-center justify-between py-2.5 px-3 hover:bg-gray-50 rounded-lg transition-colors group"
    >
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        <span className={`text-xs font-bold w-6 h-6 flex items-center justify-center rounded-lg flex-shrink-0 ${
          index < 3
            ? (isHot ? 'bg-red-100 text-red-600' : 'bg-orange-100 text-orange-600')
            : 'bg-gray-100 text-gray-500'
        }`}
        >
          {index + 1}
        </span>
        <div className="min-w-0">
          <p className="text-sm font-medium text-gray-800 truncate">{job.name}</p>
          <p className="text-xs text-gray-400">
            <span className="text-gray-500">{job.previous.toLocaleString()}</span>
            <span className="mx-1">→</span>
            <span className="font-medium text-gray-700">{job.current.toLocaleString()}</span>
          </p>
        </div>
      </div>
      
      <div className="flex items-center space-x-3 flex-shrink-0">
        <div className="w-16 h-8 opacity-60 group-hover:opacity-100 transition-opacity">
          <StandardLineChart data={trendData} color={color} height={28} showArea={false} />
        </div>
        <span className={`text-sm font-bold w-14 text-right ${isHot ? 'text-red-500' : 'text-green-600'}`}>
          {isHot ? job.growth : job.decline}
        </span>
      </div>
    </motion.div>
  )
}

// ========== 第二层：火热岗位面板 ==========
const HotJobsPanel = () => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.05 }}
    className="bg-white rounded-xl border border-gray-200 p-4"
  >
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-red-50 rounded-lg flex items-center justify-center">
          <Flame size={16} className="text-red-500" />
        </div>
        <div>
          <span className="text-sm font-bold text-gray-900">火热岗位TOP5</span>
          <span className="text-xs text-gray-400 ml-2">30天涨幅</span>
        </div>
      </div>
      <span className="text-xs text-red-500 bg-red-50 px-2 py-1 rounded-full font-medium">需求量暴涨</span>
    </div>
    
    <div className="divide-y divide-gray-50">
      {HOT_JOBS_TOP5.map((job, index) => (
        <JobRankRow key={job.name} job={job} index={index} type="hot" />
      ))}
    </div>
  </motion.div>
)

// ========== 第三层：下降岗位面板 ==========
const DeclineJobsPanel = () => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.1 }}
    className="bg-white rounded-xl border border-gray-200 p-4"
  >
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center space-x-2">
        <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center">
          <TrendingDown size={16} className="text-green-500" />
        </div>
        <div>
          <span className="text-sm font-bold text-gray-900">下降岗位TOP5</span>
          <span className="text-xs text-gray-400 ml-2">30天跌幅</span>
        </div>
      </div>
      <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full font-medium">需求量萎缩</span>
    </div>
    
    <div className="divide-y divide-gray-50">
      {DECLINE_JOBS_TOP5.map((job, index) => (
        <JobRankRow key={job.name} job={job} index={index} type="decline" />
      ))}
    </div>
  </motion.div>
)

const IntelligenceCard = ({ item, index }) => {
  const config = TYPE_CONFIG[item.type] || TYPE_CONFIG['趋势']
  const Icon = config.icon

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className={`card p-5 border-l-4 ${config.borderColor} hover:shadow-md transition-shadow`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color} flex items-center`}>
            <Icon size={12} className="mr-1" />
            {item.type}
          </span>
          {item.isUrgent && (
            <span className="px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs font-bold">
              紧急
            </span>
          )}
        </div>
        <span className="text-xs text-gray-400">{item.publishTime}</span>
      </div>

      <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
      <p className="text-sm text-gray-600 mb-3">{item.summary}</p>

      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <span className="text-xs text-gray-400">来源: {item.source}</span>
        </div>
        <div className="flex space-x-2">
          {item.tags.map(tag => (
            <span key={tag} className="px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  )
}

const IntelligencePage = () => {
  const [intelligence, setIntelligence] = useState(MOCK_INTELLIGENCE)
  const [filter, setFilter] = useState('all')

  const filters = [
    { key: 'all', label: '全部' },
    { key: '招聘', label: '招聘' },
    { key: '截止提醒', label: '截止提醒' },
    { key: '经验', label: '经验分享' },
    { key: '趋势', label: '行业趋势' }
  ]

  const filteredData = filter === 'all'
    ? intelligence
    : intelligence.filter(item => item.type === filter)

  return (
    <div className="max-w-6xl mx-auto">
      {/* 页面标题 */}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-6">
        <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
          <Newspaper size={16} className="mr-2" />
          每日更新
        </div>
        <h1 className="section-title">央国企求职情报</h1>
        <p className="section-subtitle">最新招聘、截止提醒、经验分享、行业趋势</p>
      </motion.div>

      {/* ====== 三层趋势图 - 真实数据 + 标准折线 ====== */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="mb-6"
      >
        {/* 第一层：总趋势 - 真实31天数据 */}
        <TotalTrendLayer />

        {/* 第二、三层：上涨+下降 并排 */}
        <div className="grid md:grid-cols-2 gap-4 mt-4">
          <HotJobsPanel />
          <DeclineJobsPanel />
        </div>
      </motion.div>

      {/* 筛选器 */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}
        className="flex flex-wrap gap-2 mb-6">
        {filters.map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              filter === f.key ? 'bg-primary-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {f.label}
          </button>
        ))}
      </motion.div>

      {/* 情报列表 */}
      <div className="space-y-4">
        {filteredData.map((item, index) => (
          <IntelligenceCard key={item.id} item={item} index={index} />
        ))}
      </div>

      {filteredData.length === 0 && (
        <div className="text-center py-12">
          <Newspaper size={48} className="mx-auto text-gray-300 mb-4" />
          <p className="text-gray-500">暂无该类情报</p>
        </div>
      )}

      {/* 更新时间 */}
      <div className="mt-8 text-center text-xs text-gray-400">
        <div className="flex items-center justify-center space-x-2">
          <Clock size={14} />
          <span>每日凌晨2:00-4:00更新 | 上次更新: 2026-04-26 06:00</span>
        </div>
      </div>
    </div>
  )
}

export default IntelligencePage
